/**
 * 成果分析
 */

import ppt from '@/assets/images/achievement/achievement-ppt.png';
import pdf from '@/assets/images/achievement/achievement-pdf.png';
import word from '@/assets/images/achievement/achievement-word.png';
import excel from '@/assets/images/achievement/achievement-excel.png';
import defaultFile from '@/assets/images/achievement/default-file.png';
import { createTaskApi } from '@/api/results';

// 成果分析首页
export const resultsIndexMixin = {
  data() {
    return {
      ppt,
      pdf,
      word,
      excel,
      defaultFile,
      loading: false,
      textarea: '',
      uploadFile: null,
      fileType: null,
    };
  },
  methods: {
    // 选择文件
    handleFileChange(file) {
      // 初始化
      this.uploadFile = this.fileType = null;

      // 校验文件
      let size = 20; // 文件大小
      let isLimit = file.size / 1024 / 1024 < size;
      if (!isLimit) {
        this.$message.error(`上传的文件大小不能超过 ${size}MB!`);
        return false;
      }

      // 保存文件对象
      this.uploadFile = file.raw;

      // 文件类型
      let type = file.name?.split('.').pop()?.toLowerCase() || '';
      if (type.includes('doc')) {
        this.fileType = word;
      } else if (type.includes('xls')) {
        this.fileType = excel;
      } else if (type.includes('pdf')) {
        this.fileType = pdf;
      } else if (type.includes('ppt')) {
        this.fileType = ppt;
      } else {
        this.fileType = defaultFile;
      }
    },
    // 删除文件
    deleteFile() {
      this.uploadFile = this.fileType = null;
    },
    // 提交
    handleSubmit() {
      if (!this.textarea && !this.uploadFile) {
        this.$message.warning('请输入成果描述或上传文件！');
        return;
      }
      this.loading = true;
      let formData = new FormData();
      formData.append('userId', localStorage.getItem('at_userId'));
      if (this.textarea) {
        formData.append('question', this.textarea);
      }
      if (this.uploadFile) {
        formData.append('document', this.uploadFile);
      }
      createTaskApi(formData).then(res => {
        if (res?.status === 'PENDING') {
          setTimeout(() => {
            this.$router.push({
              name: this.$route.name === 'resultsAnalysisGuoJiao' ? 'resultsDetailsGuoJiao' : 'resultsDetails',
              query: { id: res.taskId }
            })
          }, 200);
        }
        this.loading = false;
      }).catch(error => {
        // 付费弹窗
        if (error.response?.status === 429) {
          this.confirmPay();
          return false;
        }
        // 其他错误处理
        else {
          this.$message.error('服务器出错啦，请稍后重试');
        }
      }).finally(() => {
        this.loading = false;
      })
    },

    // 是否购买 对话框
    confirmPay() {
      this.$confirm('您的访问次数已达上限，如需继续使用可购买次数，是否立即购买？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '立即购买',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refs.achievementPayment.open();
      }).catch(() => {
      });
    },
  },
}


import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify'
import 'github-markdown-css';
import _ from 'lodash';
import { REQUEST_BASE_URL } from '@/api/baseAPi';
import { taskStatusApi, analysisDetailApi, achievementPdfApi, recreateTaskApi } from '@/api/results';
import { splitResponseByModulesEnhanced } from '@/utils/splitResponse';

// 成果分析详情
export const resultsDetailsMixin = {
  data () {
    return {
      userId: '',
      token: '',
      loading: false,
      id: '',
      status: '', // 成果分析 status
      question: '', //用户输入
      documentName: '', // 文件名称
      sideMenuFixed: false,
      menuCurrent: 1,
      menuList: [
        {
          id: 1,
          label: '成果概述',
        },
        {
          id: 2,
          label: '核心问题及解决方案',
        },
        {
          id: 3,
          label: '关键技术点及竞争优势',
        },
        {
          id: 4,
          label: '成果估值',
        },
        {
          id: 5,
          label: '应用与市场前景',
        },
        {
          id: 6,
          label: '转化可行性分析',
        },
        {
          id: 7,
          label: '转化价值与建议',
        },
        {
          id: 8,
          label: '企业匹配',
        },
        {
          id: 9,
          label: '企业详细分析',
        },
        {
          id: 10,
          label: '企业需求推荐',
        },
        {
          id: 11,
          label: '综合建议与总结',
        },
      ],
      taskData: {},
      resultData: {}, // 成果分析详情

      rawContent: '', // 原始流数据
      isStreaming: false, // 是否正在接收流数据
      receivedChunks: 0, // 接收的数据块数量

      startLoading: false,
      thinkLoading: false,
      reportLoading: false,

      thinkingContent: '', // 思考过程
      reporterContent: '', // 报告 流式输出

      thinkingMd: '', // 思考过程 md
      reporterMd: '', // 报告 md

      pdfLoading: false,

      splitStr: [
        '<成果概述></成果概述>',
        '<核心问题及解决方案></核心问题及解决方案>',
        '<关键技术点及竞争优势></关键技术点及竞争优势>',
        '<成果估值></成果估值>',
        '<应用与市场前景></应用与市场前景>',
        '<转化可行性分析></转化可行性分析>',
        '<转化价值与建议></转化价值与建议>',
        '<企业匹配></企业匹配>',
        '<企业详细分析></企业详细分析>',
        '<企业需求推荐></企业需求推荐>',
        '<综合建议与总结></综合建议与总结>'
      ],

      // MarkdownIt配置
      md: new MarkdownIt({
        html: true, // 禁止HTML标签
        breaks: false, // 将 \n 转换为 <br>
        linkify: true, // 自动识别链接
        typographer: true, // 优化排版
      }),
    }
  },
  created () {
    this.id = this.$route.query.id;
    this.userId = this.$store.state.id || localStorage.getItem('at_userId');
    this.token = this.$store.getters.getToken || localStorage.getItem('at_token');

    if (this.id) {
      this.getAnalysisStatus();
    } else {
      this.loading = true;
      this.$message({
        type: 'warning',
        message: '缺少id参数，即将跳转成果分析首页',
        duration: 900,
      });
      setTimeout(() => {
        this.$router.push({
          name: this.$route.name === 'resultsDetailsGuoJiao' ? 'resultsAnalysisGuoJiao' : 'resultsAnalysis'
        });
      }, 800)
    }
  },
  methods: {
    splitResponseByModulesEnhanced,

    // 点击 我的指令
    handleOpen() {
      this.$refs.questionDialog.open();
    },

    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.resultsContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    // 渲染markdown
    markdownRenderer(content) {
      if (!content) return '';
      const rawHtml = this.md.render(content);
      return DOMPurify.sanitize(rawHtml);
    },

    // 监听滚动
    watchScroll() {
      let dom = this.$refs.resultsContainer;
      if (!dom) return false;

      const scrollY = dom.scrollTop;
      // 从后往前遍历，找到第一个 offsetTop <= scrollY 的 section（即当前可视区域顶部所在的 section）
      let currentId = 1; // 默认第一个
      for (let i = this.menuList.length - 1; i >= 0; i--) {
        const id = this.menuList[i].id;
        const el = document.getElementById(String(id));
        if (el) {
          // offsetTop 是相对于 offsetParent 的，但在 body 下通常就是文档坐标
          // 更稳妥的方式：使用 getBoundingClientRect + scrollY
          const rect = el.getBoundingClientRect();
          const top = rect.top + scrollY;

          // 判断：滚动位置是否已进入该 section（可加偏移避免临界抖动）
          if (scrollY >= top - 134) { // -100 是偏移量，让高亮提前触发，体验更顺滑， 34 是顶部导出pdf按钮高度
            currentId = id;
            break;
          }
        }
      }

      this.menuCurrent = currentId;
    },

    // 切换侧边栏
    changeMenu(event, id) {
      this.menuCurrent = id;
      event.preventDefault();
      const dom = document.getElementById(id);
      if (dom) {
        dom.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },

    // 导出pdf
    async exportPdf() {
      if (!this.status || (this.status !== 'SUCCESS' && this.status !== 'FAIL')) {
        this.$message.warning('成果分析还未生成完，请稍后再试');
        return false;
      }

      if (this.status === 'FAIL') {
        this.$message.error('成果分析生成失败，无法导出PDF');
        return false;
      }

      this.pdfLoading = true;

      try {
        let id = this.id;
        const res = await achievementPdfApi(id);
        // console.log(res);

        if (res.code === 200) {
          if (res.message === '已有重复PDF，无需再次生成') {
            this.$message.success('报告已存在, 请到“文件管理”中查看');
          } else if (res.message === 'PDF生成成功') {
            this.$message.success('报告生成成功, 请到“文件管理”中查看');
          }
        } else {
          this.$message.error(res.message || '报告生成失败，请刷新后再试');
        }
        this.pdfLoading = false;
      } catch (error) {
        this.pdfLoading = false;
        console.error('导出PDF失败:', error);
        throw error;
      } finally {
        this.pdfLoading = false;
      }
    },

    // 获取 成果分析状态
    getAnalysisStatus() {
      this.status = '';
      taskStatusApi(this.id).then(res => {
        this.status = res.status || '';
        this.question = res.userInput || '';
        this.documentName = res.documentName || '';
        if (res.status === 'SUCCESS') {
          // SUCCESS 非流式
          this.getDetails();
        } else if (res.status === 'FAIL') {
          // FAIL 重新生成   this.$message.warning('成果分析生成出错，正在重新生成');
          this.recreateTask();
        } else if (res.status) {
          // PENDING、RUNNING 流式
          this.startStream();
        } else {
          // 库里没有找到id
          this.$message({
            type: 'warning',
            message: '成果分析详情不存在，即将跳转成果分析首页',
            duration: 1400,
          });
          setTimeout(() => {
            this.$router.push({
              name: this.$route.name === 'resultsDetailsGuoJiao' ? 'resultsAnalysisGuoJiao' : 'resultsAnalysis'
            });
          }, 1450)
        }
      })
    },

    // 重新生成 成果分析
    recreateTask() {
      recreateTaskApi(this.id).then( res => {
        if (res.code === 200) {
          this.startStream();
        } else {
          this.$message.error('检测到上传的文件已过期或不存在，请重新创建成果分析！');
        }
      })
    },

    // 成果分析详情
    getDetails() {
      this.loading = true;
      analysisDetailApi(this.id).then(res => {
        if (res && res.taskId && res.resultData) {
          // 思考过程
          this.thinkingContent = res.resultData?.think_progress || '';
          this.thinkingMd = this.markdownRenderer(this.thinkingContent);
          // 成果分析
          let reportContent = res.resultData?.chunk_text || '';
          let modules = this.splitResponseByModulesEnhanced(reportContent, this.splitStr);
          const rendered = {};
          for (const key in modules) {
            const content = modules[key];
            rendered[key] = this.markdownRenderer(content);
          }
          this.resultData = rendered;

          this.loading = false;
          // 折叠思考过程、手动更新菜单高亮
          this.$nextTick(() => {
            if (this.$refs.toggleRef1) {
              this.$refs.toggleRef1.toggle();
            }
            this.watchScroll();
          });
        }
      }).finally(() => {
        this.loading = false;
      })
    },

    // 接收流数据
    async startStream() {
      if (this.isStreaming) return false;

      this.rawContent = '';
      this.thinkingContent = '';
      this.reporterContent = '';
      this.receivedChunks = 0;

      // url
      const url = REQUEST_BASE_URL + (process.env.VUE_APP_NAME === 'guojiao' ? '/api-key' : '') + '/api/analysis/stream/result/' + this.id;
      this.isStreaming = true;
      this.thinkLoading = true;

      this.startLoading = true;

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'text/event-stream',
            'Authorization': process.env.VUE_APP_NAME === 'guojiao' ? this.token : 'Bearer ' + this.token,
          },
        });

        if (!response.ok) throw new Error(`HTTP错误 ${response.status}`);

        // 创建流式读取器
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');

        // 递归读取流数据
        const readChunk = async () => {
          const { done, value } = await reader.read();

          this.startLoading = false;

          if (done) {
            this.processChunk(); // 处理最后剩余数据
            this.thinkLoading = false;
            this.reportLoading = false;
            this.isStreaming = false;
            // console.log('流式传输结束 2');
            return;
          }

          // 解码并处理数据块
          this.rawContent += decoder.decode(value, { stream: true });
          this.processChunk();

          // 继续读取下一个块
          await readChunk();
        };

        await readChunk();

      } catch (error) {
        this.$message.error(error.message);
        this.isStreaming = false;
        this.thinkLoading = false;
        this.reportLoading = false;
        this.startLoading = false;
        // this.recreateTask();
      }
    },

    // 处理流数据
    processChunk() {
      // 按换行符分割完整数据包
      const packets = this.rawContent.split('\n');
      this.rawContent = packets.pop() || ''; // 保留不完整数据

      packets.forEach((packet) => {
        if (!packet.trim()) return;

        try {
          const cleanData = packet.replace(/^data: /, '');
          const parsed = JSON.parse(cleanData); // 合法的JSON

          switch (parsed.type) {
            case 'think_progress':
              // eslint-disable-next-line no-case-declarations
              const thinking = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              this.thinkingContent += thinking;
              break;

            case 'chunk_text':
              this.thinkLoading = false;
              this.reportLoading = true;
              // eslint-disable-next-line no-case-declarations
              const reporter = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              this.reporterContent += reporter;
              break;

            case 'complete':
              this.thinkLoading = false;
              this.reportLoading = false;
              this.isStreaming = false;
              // eslint-disable-next-line no-case-declarations
              let modules = this.splitResponseByModulesEnhanced(this.reporterContent, this.splitStr);
              // eslint-disable-next-line no-case-declarations
              let rendered = {};
              for (const key in modules) {
                const content = modules[key];
                rendered[key] = this.markdownRenderer(content);
              }
              this.resultData = rendered;

              // 折叠思考过程
              this.$nextTick(() => {
                if (this.$refs.toggleRef1) {
                  this.$refs.toggleRef1.toggle();
                }
              })
              // console.log('流式传输结束 1');
              break;

            case 'error':
              // eslint-disable-next-line no-case-declarations
              const errContent = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              console.log(errContent, 'errContent');
              break;
          }

          // 滚动dom
          this.$nextTick(() => {
            if (this.isStreaming) {
              // 滚动到底部
              this.scrollToBottom();
            } else {
              // 刷新任务
              this.updateTask();
            }
          })

          // 更新计数器
          this.receivedChunks++

        } catch (e) {
          console.warn('JSON解析错误:', e, '原始数据:', packet);
        }
      })
    },

    // 刷新任务
    updateTask() {
      // 刷新 成果分析状态
      // console.log('刷新 成果分析状态 @@@');
      this.getAnalysisStatus();
      // 滚动到顶部
      let dom = this.$refs.resultsContainer;
      setTimeout(() => {
        dom && dom.scrollTo({ top: 0, behavior: 'smooth'});
      }, 800);
    },

    // 新会话
    handleBack() {
      this.$router.push({
        name: this.$route.name === 'resultsDetailsGuoJiao' ? 'resultsAnalysisGuoJiao' : 'resultsAnalysis'
      });
    },
  },
  watch: {
    'thinkingContent': {
      handler: _.debounce( function(nv) {
        this.thinkingMd = this.markdownRenderer(nv);
      }, 100),
      // immediate: true,
      deep: true,
    },
    'reporterContent': {
      handler: _.debounce( function(nv) {
        this.reporterMd = this.markdownRenderer(nv);
        this.$nextTick(() => {
          nv && this.scrollToBottom();
        })
      }, 100),
      // immediate: true,
      deep: true,
    },
  }
}
